import {useTableOfContentsItems} from "../../hooks/tableOfContentsHooks/useTableOfContentsItems";
import styles from "./TableOfContentsMenu.module.scss";
import TableOfContentsList from "./TableOfContentsList";
import React from "react";
import {useTableOfContents} from "../../hooks/tableOfContentsHooks/useTableOfContents";
import {getTocName} from "../../utils/getTocName";

const TableOfContentsSideMenu = ({ msPath }) => {
  useTableOfContentsItems(msPath);
  const tocContext = useTableOfContents();

  return (
    <div aria-label="Table of Contents Side Menu">
      <div className={styles.header}>
        <div className={styles.topicTitle}>
          <h1>{getTocName(msPath)}</h1>
        </div>

        <div className={styles.title}>
          <h3>{tocContext.tableOfContents?.title}</h3>
        </div>
      </div>
      <div className={styles.content}>
        {tocContext.tableOfContents?.children?.length > 0 && (
          <TableOfContentsList items={tocContext.tableOfContents.children} />
        )}
      </div>
    </div>
  );
}

export default TableOfContentsSideMenu;